<div class="relative flex items-center">
  @if (examDirection().side === 'right') {
    <svg xmlns="http://www.w3.org/2000/svg" width="199" height="12" fill="none">
      <path
        fill="#1B87EA"
        d="M.47 5.47a.75.75 0 0 0 0 1.06l4.773 4.773a.75.75 0 1 0 1.06-1.06L2.061 6l4.242-4.243a.75.75 0 0 0-1.06-1.06L.47 5.47ZM199 6v-.75H1v1.5h198V6Z"
      />
    </svg>
  }
  <div
    class="flex aspect-square h-6 items-center justify-center overflow-visible rounded-full border-[1.5px] border-primary-blue-pressed bg-primary-blue text-h7 font-medium text-text-white shadow-lg"
  >
    {{ examDirection().label }}
  </div>

  @if (examDirection().side === 'left') {
    <svg width="199" height="12" viewBox="0 0 199 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M198.53 6.53033C198.823 6.23744 198.823 5.76256 198.53 5.46967L193.757 0.696699C193.464 0.403806 192.99 0.403806 192.697 0.696699C192.404 0.989593 192.404 1.46447 192.697 1.75736L196.939 6L192.697 10.2426C192.404 10.5355 192.404 11.0104 192.697 11.3033C192.99 11.5962 193.464 11.5962 193.757 11.3033L198.53 6.53033ZM0 6V6.75H198V6V5.25H0V6Z"
        fill="#1B87EA"
      />
    </svg>
  }
</div>
